import React from "react";

const Content = ({ children }) => <div className="content-wrapper">{children}</div>;

export default Content;



// WEBPACK FOOTER //
// ./src/layouts/main/content/Content.js